<template>
  <v-footer color="primary" padless :app="!mobile" inset>
    <v-row justify="space-around" no-gutters>
      <template
        v-if="
          rutaActual &&
          rutaActual !== 'login' &&
          rutaActual !== 'crear_contrasena'
        "
      >
        <v-btn
          v-for="link in links"
          :key="link.name"
          color="white"
          text
          x-small
          :block="mobile"
          rounded
          class="my-1"
          @click="link.text ? copiarTexto(link.text) : ''"
          :href="link.link ? link.link : ''"
          target="_blank"
        >
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon small left> {{ link.icon }}</v-icon>
              <span
                v-bind="attrs"
                v-on="on"
                @mouseleave="link.text ? (copyText = 'Copiar') : ''"
                :class="mobile ? 'texto-footer' : ''"
              >
                {{ link.name }}
              </span>
            </template>
            <span v-if="link.span">{{ link.span }}</span>
            <span v-else>{{ copyText }}</span>
          </v-tooltip>
        </v-btn>
      </template>

      <v-col class="secondary text-center white--text" cols="12">
        ©
        <strong class="link-style">
          <a
            class="white--text text-decoration-none"
            href="https://www.maximizaerp.cl/"
          >
            Maximiza
          </a>
        </strong>
        {{ new Date().getFullYear() }}
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              style="opacity: 0 !important"
              icon
              small
              absolute
              right
            >
              <v-icon small left> mdi-help-box </v-icon>
            </v-btn>
          </template>
          <span>{{ build }}</span>
        </v-tooltip>
      </v-col>
    </v-row>
  </v-footer>
</template>

<script>
import { mapActions } from "vuex";

export default {
  data: () => ({
    copyText: "Copiar",
    build: process.env.VUE_APP_BUILD_DATE,
    links: [
      {
        name: "atencionsocios@cooptalcahuano.cl",
        icon: "mdi-email",
        text: "atencionsocios@cooptalcahuano.cl"
      },
      {
        icon: "mdi-map-marker",
        name: "Blanco Encalada 444, Talcahuano, Bío Bío",
        link: "https://goo.gl/maps/X7MvTuq15WNMTC5i7",
        span: "Ver en Google Maps"
      },
      {
        name: "(41)2183275 - (41)2183279 - (41)2183276",
        icon: "mdi-phone",
        text: "+56228192620"
      }
    ]
  }),
  methods: {
    ...mapActions(["switchDrawer"]),
    copiarTexto(value) {
      navigator.clipboard.writeText(value);
      this.copyText = "Copiado !";
    }
  },
  computed: {
    mobile() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return true;
        case "sm":
          return true;
        case "md":
          return false;
        case "lg":
          return false;
        case "xl":
          return false;
        default:
          return false;
      }
    },
    rutaActual() {
      return this.$route.name;
    }
  },
  mounted() {
    if (this.mobile) {
      this.switchDrawer(false);
    }
  }
};
</script>
<style scoped lang="css">
.texto-footer {
  width: min-content;
  white-space: normal;
  flex: auto;
}
</style>
